export default __webpack_public_path__ + "static/media/kyungjae_crop_resize.6d8cfaec.jpg";